import * as actions from './actions';

export const showModalWithCallback = (content, callback)=> {
  return dispatch => {
    dispatch(actions.setModalContent(content));
    dispatch(actions.setModalCallback(callback));
    dispatch(actions.setConfirmModalVisible(true));
  };
};